var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("分账规则配置")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("分账规则配置"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "服务省", prop: "type1" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择" },
                                    on: { change: _vm.cityChange1 },
                                    model: {
                                      value: _vm.ruleForm.type1,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "type1", $$v)
                                      },
                                      expression: "ruleForm.type1",
                                    },
                                  },
                                  _vm._l(_vm.city, function (item, index) {
                                    return _c("el-option", {
                                      key: item.adcode,
                                      attrs: {
                                        label: item.name,
                                        value: item.adcode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.ruleForm.type1 != "100000"
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "服务城市",
                                      prop: "select",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { "margin-right": "auto" },
                                        attrs: { placeholder: "请选择" },
                                        model: {
                                          value: _vm.ruleForm.select,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "select",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.select",
                                        },
                                      },
                                      _vm._l(_vm.city2, function (item, index) {
                                        return _c("el-option", {
                                          key: item.adcode,
                                          attrs: {
                                            label: item.name,
                                            value: item.adcode,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "停用", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "启用", value: "1" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                staticStyle: { "margin-bottom": "16px" },
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.add()
                  },
                },
              },
              [_vm._v("添加配置规则")]
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "code", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "规则名称", align: "center", prop: "name" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "当前规则", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(
                          scope.row.roleCommissionRatioList,
                          function (item, index) {
                            return _c("span", { key: index }, [
                              _vm._v(
                                _vm._s(item.profitShareRoleName) +
                                  ":" +
                                  _vm._s(item.commissionRatio)
                              ),
                              index <
                              scope.row.roleCommissionRatioList.length - 1
                                ? _c("span", [
                                    _vm._v(
                                      "\n                |\n              "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          }
                        )
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("待生效"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("生效中"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            scope.row.status == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn greenColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                启用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.stop(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                停用\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            scope.row.status != 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteItem(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                删除\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                "current-page": _vm.page,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "850px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticStyle: { margin: "0 auto" },
              attrs: {
                "label-position": "right",
                model: _vm.ruleForm1,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规则名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入规则名称" },
                    model: {
                      value: _vm.ruleForm1.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "name", $$v)
                      },
                      expression: "ruleForm1.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "城市选择", prop: "type1" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-right": "auto" },
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.cityChange },
                          model: {
                            value: _vm.ruleForm1.type1,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "type1", $$v)
                            },
                            expression: "ruleForm1.type1",
                          },
                        },
                        _vm._l(_vm.city, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.adcode },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm1.type1 != "100000"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "select" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { "margin-right": "auto" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm1.select,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm1, "select", $$v)
                                },
                                expression: "ruleForm1.select",
                              },
                            },
                            _vm._l(_vm.city1, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.adcode },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { label: "用户类型", prop: "utype" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm1.utype,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "utype", $$v)
                        },
                        expression: "ruleForm1.utype",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("公司"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("个人"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "任务场景", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.ruleForm1.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "type", $$v)
                        },
                        expression: "ruleForm1.type",
                      },
                    },
                    _vm._l(_vm.employscene, function (item) {
                      return _c("el-option", {
                        key: item.propValue,
                        attrs: { label: item.title, value: item.propValue },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "平台抽佣比例", prop: "proportion" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { placeholder: "请输入", type: "number" },
                      model: {
                        value: _vm.ruleForm1.proportion,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "proportion", $$v)
                        },
                        expression: "ruleForm1.proportion",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "保安公司邀请奖励", prop: "" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { placeholder: "请输入", type: "number" },
                      model: {
                        value: _vm.ruleForm1.money,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "money", $$v)
                        },
                        expression: "ruleForm1.money",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分账角色选择", prop: "rule" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { multiple: "", placeholder: "请选择" },
                      on: { change: _vm.selectRule },
                      model: {
                        value: _vm.ruleForm1.rule,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "rule", $$v)
                        },
                        expression: "ruleForm1.rule",
                      },
                    },
                    _vm._l(_vm.ruleList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectRuleList.length > 0
                ? _c(
                    "div",
                    { staticStyle: { "font-weight": "600", margin: "10px 0" } },
                    [
                      _vm._v(
                        "\n        分账比例配置（总和=平台抽佣比例）\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.selectRuleList, function (item, index) {
                return _c(
                  "el-form-item",
                  {
                    key: item.propValue,
                    attrs: { label: item.profitShareRoleName, prop: "type" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex", width: "100%" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticStyle: { width: "150px", height: "30px" },
                            attrs: { placeholder: "", type: "number" },
                            model: {
                              value: item.commissionRatio,
                              callback: function ($$v) {
                                _vm.$set(item, "commissionRatio", $$v)
                              },
                              expression: "item.commissionRatio",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("%")])],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "el-input",
                          {
                            staticStyle: {
                              width: "150px",
                              margin: "0 10px",
                              height: "30px",
                            },
                            attrs: { placeholder: "", type: "number" },
                            model: {
                              value: item.weightMain,
                              callback: function ($$v) {
                                _vm.$set(item, "weightMain", $$v)
                              },
                              expression: "item.weightMain",
                            },
                          },
                          [
                            _c("template", { slot: "prepend" }, [
                              _vm._v("权重"),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "el-popover",
                          {
                            ref: "myPopover",
                            refInFor: true,
                            attrs: { placement: "top", trigger: "click" },
                            model: {
                              value: item.show,
                              callback: function ($$v) {
                                _vm.$set(item, "show", $$v)
                              },
                              expression: "item.show",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "space-between",
                                      margin: "10px 0",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "50",
                                        clearable: "",
                                        placeholder: "请输入分账主体名称",
                                      },
                                      model: {
                                        value: _vm.torgValue,
                                        callback: function ($$v) {
                                          _vm.torgValue = $$v
                                        },
                                        expression: "torgValue",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "btn",
                                        staticStyle: { "margin-left": "10px" },
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getorgList()
                                          },
                                        },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: {
                                      height: "300px",
                                      "overflow-y": "scroll",
                                    },
                                    attrs: {
                                      data: _vm.orgList,
                                      "row-key": "id",
                                    },
                                    on: { "row-click": _vm.handleSelect },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "accountId",
                                        label: "ID",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "accountName",
                                        label: "账户名称",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        property: "accountType",
                                        label: "账户类型",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.accountType == 1
                                                  ? _c("span", [
                                                      _vm._v("平台账户"),
                                                    ])
                                                  : scope.row.accountType == 2
                                                  ? _c("span", [
                                                      _vm._v("客户账户"),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              color: "blue",
                              "margin-left": "10px",
                            },
                            attrs: { slot: "reference" },
                            on: {
                              click: function ($event) {
                                return _vm.selectData(index)
                              },
                            },
                            slot: "reference",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  item.accountName
                                    ? item.accountName
                                    : "绑定分账主体"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm1("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }